import React from 'react';
import { useImageLibraryStore } from '../../state/createImageLibraryStore';
import { useActions } from '../../hooks/useStore';
import CharacterSheetModal from './CharacterSheetModal';
import type { PartyMember, Image } from '../../types/types';

interface CharacterSheetModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
  player: PartyMember | null;
}

/**
 * Container for CharacterSheetModal (ADR-034).
 * Owns store access for image library and updatePlayer action.
 * The `player` prop is already provided by the UI store in AppProvidersLayout.
 */
const CharacterSheetModalContainer: React.FC<CharacterSheetModalContainerProps> = ({
  isOpen,
  onClose,
  player,
}) => {
  const imageLibrary: Image[] = useImageLibraryStore(state => state.images);
  const actions = useActions();

  const handleUpdatePlayer = async (updatedPlayer: Partial<PartyMember> & { id: number }) => {
    await actions.updatePlayer(updatedPlayer);
  };

  return (
    <CharacterSheetModal
      isOpen={isOpen}
      onClose={onClose}
      player={player}
      imageLibrary={imageLibrary}
      onUpdatePlayer={handleUpdatePlayer}
    />
  );
};

export default CharacterSheetModalContainer;
